/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/650/interface/api/cat_11357
 */

import { message } from 'ant-design-vue'
import {
  config_return_addReturnConfig_post,
  config_return_editReturnConfig_post,
  config_return_enableConfig_post,
  config_return_log_list_activityId_get,
  config_return_queryReturnConfig_id_get,
  config_return_queryReturnConfigList_post,
  config_return_queryReturnConfigSkc_post,
  config_return_upload_siteId_terminalId_channelId_brandId_post,
  config_return_exportReturnSkc_post,
  config_return_noReturnCategoryQuery_post
} from 'server/modules/11357'

// 增加return配置
export const config_return_addReturnConfig_post_ = async function(params) {
  const { success, data, retInfo } = await config_return_addReturnConfig_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑return配置
export const config_return_editReturnConfig_post_ = async function(params) {
  const { success, data, retInfo } = await config_return_editReturnConfig_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 启用
export const config_return_enableConfig_post_ = async function(params) {
  const { success, data, retInfo } = await config_return_enableConfig_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询操作日志
export const config_return_log_list_activityId_get_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_return_log_list_activityId_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// return配置详情
export const config_return_queryReturnConfig_id_get_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_return_queryReturnConfig_id_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// return配置列表
export const config_return_queryReturnConfigList_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_return_queryReturnConfigList_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// return配置skc列表
export const config_return_queryReturnConfigSkc_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_return_queryReturnConfigSkc_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 上传skc文件
export const config_return_upload_siteId_terminalId_channelId_brandId_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_return_upload_siteId_terminalId_channelId_brandId_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// return配置导出
export const config_return_exportReturnSkc_post_ = async function(params) {
  const { success, data, retInfo } = await config_return_exportReturnSkc_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// no return活动查询
export const config_return_noReturnCategoryQuery_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_return_noReturnCategoryQuery_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
